import { SuportAreaTranslations } from "./suport-area-pt-br";

export const SUPORT_AREA_ES_ES: SuportAreaTranslations = {
	title: "Centro de ayuda",
	questionTitle: "¿Necesitas ayuda?",
	questionDescription: "Abre un ticket y habla con nuestro equipo de soporte.",
	openTicket: "Nuevo ticket",
	close: "Cerrar",
};
